import React from "react";
import Chart from "react-apexcharts";

export default function LocalEducationChart({data}) {
  


  const totalCount = data?.reduce((sum, item) => sum + item.count, 0);
  const names = data?.map(n => n?.name);
  const quantities = data?.map(
    (item) => parseFloat(((item.count / totalCount) * 100).toFixed(1)) // Round to 2 decimal places
  );

  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#22A385","#12BD95", "#9DE1D1"],
    chart: {
      type: "pie",
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        return `${val}%`;
      },
      style: {
        fontSize: '14px',
        colors: ['#000'],
        fontWeight: 'normal'
      },
      dropShadow: {
        enabled: false
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -35,
          },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val}%`;
        },
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: "300",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: "230",
          },
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
    ]
  };

  const series = quantities;

  return <Chart options={options} series={series} type="pie" width="400" className="chart-center" />;
}
